<template>
	<div class="order-new">
		<div class="success">
			<img src="/static/img/payicon.png">
			<div class="message blue">订单提交成功</div>
			<div class="tip">您需要将订单分享给客户</div>
			<div class="actions">
				<mt-button type="primary" v-show="is_app_customer" :disabled="disabled" @click="toPush">推送到众赢财富通App</mt-button>
				<p>&nbsp;</p>
				<mt-button type="primary" :disabled="disabled" @click="toShare">分享给客户</mt-button>
			</div>
		</div>
	</div>
</template>

<script>
import { Button } from 'mint-ui'

export default {
	name: 'OrderDetail',
	data: () => ({
		'disabled': false,
		'is_app_customer': false,
		'order': null
	}),
	computed: {
	},
	created () {
	},
	components: {
		'mt-button': Button
	},
	mounted: function () {
		this.setPageTitle('新建订单成功')
		this.fetchDetail()
	},
	methods: {
		toShare () {
			window.location.href = '#/orders/' + this.$route.params.id
		},
		fetchDetail () {
			this.loading('正在读取订单信息...')
			this.getOrderFullDetail(this.$route.params.id, 'push', rs => {
				this.order = rs.data.order
				if (rs.data.customer_code && rs.data.customer_code.length > 0) {
					this.is_app_customer = rs.data.customer_code
				}
			})
		},
		toPush () {
			this.loading('正在推送')
			this.$http.post('/api/orders/app/push/' + this.$route.params.id).then(response => {
				this.loadingHide()
				console.log(response)
				var rs = response.body
				this.toast(rs.message)
			}, response => {
				// error callback
				console.log(response)
				this.handleHttpError(response)
			})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/OrderNewSuccess.vue